import * as Yup from 'yup';

import { InvoiceItem, isInvoiceProductItem, isInvoiceTextItem } from '../../../models/invoice-item';
import { isBlankPosition, withoutBlankPositions } from '../../../../../common/components/palo/palo-first-position';
import { positionFieldNames } from '../../models/positions-form-values';

export const positionsValidationSchema = Yup.object().shape({
    [positionFieldNames.allItems]: Yup.array()
        .of(
            Yup.lazy((value: InvoiceItem) => {
                // The blank first row waits for its article and is not saved (#2308).
                if (isInvoiceProductItem(value) && isBlankPosition(value)) {
                    return Yup.object();
                }

                if (!isInvoiceTextItem(value)) {
                    return Yup.object().shape({
                        quantity: Yup.number()
                            .typeError('app.error.required')
                            .moreThan(0, 'app.error.greaterZero')
                            .required('app.error.required'),
                        price: Yup.number().typeError('app.error.required').required('app.error.required'),
                        discount: Yup.number()
                            .min(0, 'app.error.greaterZero')
                            .max(100, 'app.error.lesserHundred')
                            .typeError('app.error.required'),
                        taxRate: Yup.object().nullable().required('app.error.required'),
                        tax: Yup.number()
                            .min(0, 'app.error.greaterZero')
                            .max(100, 'app.error.lesserHundred')
                            .typeError('app.error.required'),
                    });
                }

                return Yup.object().shape({
                    title: Yup.string().typeError('app.error.required').required('app.error.required'),
                    description: Yup.string(),
                });
                // HACK: type definition of Yup.lazy seems to be wrong
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }) as any
        )
        .required('app.error.required')
        .test(
            'one-position',
            'app.error.required',
            items => 0 < withoutBlankPositions((items ?? []) as InvoiceItem[], isInvoiceProductItem).length
        ),

    [positionFieldNames.netShippingCosts]: Yup.number().typeError('app.error.required').required('app.error.required'),
    [positionFieldNames.netSurcharge]: Yup.number().required('app.error.required'),
    [positionFieldNames.isTaxFree]: Yup.boolean(),
});
